import React, { Suspense, useEffect } from 'react';
import AppRoutes from './AppRoutes';
import { BrowserRouter as Router } from 'react-router-dom';
import Loading from './shared/components/Loading';
import { Provider } from 'react-redux';
import store from './store';
import { getToken } from 'firebase/messaging';
import { toast } from 'react-toastify';
import { messaging } from './shared/firebase.service';
import { getToken as getJwttoken, valiadteToken } from './shared/utils/utils';
import { METHOD, apiCall } from './shared/services/api/baseApiCall';
import { SET_DEVICE_TOKEN_URL } from './shared/services/apiEndPoint';

const App = () => {
	const requestNotificationPermission = async () => {
		// if (!('Notification' in window)) {
		// 	// Check if the browser supports notifications
		// 	alert('This browser does not support desktop notification');
		// } else if (Notification.permission === 'granted') {
		// 	// Check whether notification permissions have already been granted;
		// } else if (Notification.permission !== 'denied') {
		// 	// We need to ask the user for permission
		// 	Notification.requestPermission().then(async permission => {
		// 		// If the user accepts, let's create a notification
		// 		if (permission === 'granted') {
		// 			const deviceId = await getToken(messaging);

		// 			const isLoggedin = valiadteToken();
		// 			const accessToken = getJwttoken('login-auth-token');
		// 			if (isLoggedin) {
		// 				//api call for save token in BE
		// 				apiCall(
		// 					SET_DEVICE_TOKEN_URL,
		// 					{ deviceId, accessToken },
		// 					(data: any) => {
		// 						console.log(data);
		// 					},
		// 					() => {
		// 						console.log('');
		// 					},
		// 					METHOD.POST,
		// 					{ showToast: false }
		// 				);
		// 			}

		// 			localStorage.setItem('deviceId', deviceId);
		// 		} else if (permission === 'denied') {
		// 			toast.info('You denied from notification', {
		// 				position: toast.POSITION.TOP_RIGHT,
		// 				autoClose: 2000
		// 			});
		// 			localStorage.removeItem('deviceId');
		// 		}
		// 	});
		// }
	};

	useEffect(() => {
		// if (localStorage.getItem('deviceId')) return;
		requestNotificationPermission();
	}, []);

	return (
		<Suspense fallback={<Loading />}>
			<Provider store={store}>
				{/* <PersistGate loading={null} persistor={persistor}> */}
				<Router>
					<AppRoutes />
				</Router>
				{/* </PersistGate> */}
			</Provider>
		</Suspense>
	);
};

export default App;
